import { mixinMethods } from '@/main'
import {
    onCreateVehicleByGroup,
    onUpdateVehicleByGroup,
    onDeleteVehicleByGroup
} from '../../subscriptions';
import store from '@/store'
import { initializeSubscription, disconnectSubscription } from '../helper'
import { API } from 'aws-amplify'
import { apiPostCompressed } from "@/utilities/apiCallCompressed";
import EventBus from '@/eventBus'

"use strict";
let subscriptionVehicles = null
let vehiclesRDS = [];

export const loadVehicles = async function(){
    if(!store.state.userInfo?.tenant?.group) return
    const input = {
        group: store.state.userInfo.tenant.group
    }
    await loadVehiclesFromRDS(input.group);
    store.dispatch("subscriptionStore/setVehicleList", vehiclesRDS)
}

async function loadVehiclesFromRDS(group) {
    let body = { 
        group: group,
        matchingFields: true,
        isMapped: true
    }

    try {
        const results = await apiPostCompressed('rds', '/query/VehicleByGroup', { body })
        if(results?.data?.length){
            vehiclesRDS = results.data
        } else {
            vehiclesRDS = []
        }
    } catch (error) {
        console.log("Error in loadVehicles", error);
        vehiclesRDS = []
    } 
}

export const vehicleSubscribe = function(instance){
    const queries = {
        onCreateVehicleByGroup,
        onUpdateVehicleByGroup,
        onDeleteVehicleByGroup
    }
    if(!store.state.userInfo?.tenant?.group) return
    const input = {
        group: store.state.userInfo.tenant.group
    }
    initializeSubscription(subscriptionVehicles, queries, input, "subscriptionStore/mutateVehicle", instance)
}

export const config = function(subscriptions){
    const subscription = {}
    subscriptionVehicles = subscriptions['vehicle'] = {
        loadList: loadVehicles,
        subscribe: vehicleSubscribe,
        unsubscribe: (instance) => disconnectSubscription(subscription, instance),
        callback: vehicleEventCallback,
        subscription
    }
}

export const vehicleEventCallback = function(subscriptionState, payload){
    if(payload.data?.id){
        EventBus.$emit('update-route-render', {
            from: "vehicle",
            vehicle: payload.data,
            eventName: payload.eventName
        })
    }
}